import React from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.topBorder}></div>

      <div className={styles.container}>
        {/* ✅ BRAND / ABOUT */}
        <div className={styles.col}>
          <div className={styles.brandRow}>
            <img
              src="/images/bniRedGreyLogo.png"
              className={styles.bniLogo}
              alt="BNI"
            />
          </div>
          <p className={styles.text}>
            BNI Brisk is a high-performing chapter built on the
            <strong> Givers Gain®</strong> philosophy — empowering entrepreneurs
            to grow through quality referrals.
          </p>
          <p className={styles.tag}>
            Changing the Way the World Does Business®
          </p>
        </div>

        {/* ✅ QUICK LINKS */}

        {window?.innerWidth > 700 && (
          <>
            <div className={styles.col}>
              <h4 className={styles.subheading}>Quick Links</h4>
              <ul className={styles.links}>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/members">Members</Link>
                </li>
                <li>
                  <Link to="/about">About BNI</Link>
                </li>
              </ul>
            </div>

            <div className={styles.col}>
              <h4 className={styles.subheading}>BNI Global</h4>
              <ul className={styles.links}>
                <li>340K+ Members</li>
                <li>11,300+ Chapters</li>
                <li>17.4M Referrals / Year</li>
                <li>$26.4B Revenue Generated</li>
              </ul>
            </div>
          </>
        )}

        {window?.innerWidth < 700 && (
          <div className={styles["footer-grid-wrapper"]}>
            <div className={styles.col}>
              <h4 className={styles.subheading}>Quick Links</h4>
              <ul className={styles.links}>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/members">Members</Link>
                </li>
                <li>
                  <Link to="/about">About BNI</Link>
                </li>
              </ul>
            </div>

            <div className={styles.col}>
              <h4 className={styles.subheading}>BNI Global</h4>
              <ul className={styles.links}>
                <li>340K+ Members</li>
                <li>11,300+ Chapters</li>
                <li>17.4M Referrals / Year</li>
                <li>$26.4B Revenue Generated</li>
              </ul>
            </div>
          </div>
        )}
      </div>

      {/* ✅ COPYRIGHT */}
      <div className={styles.copy}>
        © {new Date().getFullYear()} BNI Brisk • Powered by BNI Global
      </div>
    </footer>
  );
}
